import React, { useMemo, useContext } from "react";
import { Badge, DraftBadge } from "../../Common/NotificationPill";
import { OptionsObjList } from "../../Common/FormInput";
import Cs from "../../../services/CommonService";
import { PhoneIcon, MapIcon } from "../../Common/ImageIcons";
import { UserName } from '../../UserProfile/UserInfoPopup';
import { getLocale } from '../../FormBuilder/FieldLabel';
import { useSubscriptionAccess } from '../../Subscriptions/useSubscription';
import { LocalizeContext } from "../../../contexts/Localize/LocalizeStateProvider";
import useModal from "../../../hooks/useModal";
import { DataSourceMenu } from "../../Modals/DataSourceMenu";
import { CueTip } from "../../Common/CueTooltip";
import { SpanRichTextView } from "../../Common/RichTextView";
import {useJourneyHook} from "./useJourneyHook";

const RecordId = ({journey, openFormSubmissionReview}) =>{
  const {record_id, draft} = journey;
 
  return(
    <>
      <div>{record_id}</div>
      <DraftBadge isDraft={draft} styleName="d-block"/>
      <Badge show={journey.is_test_data} className="bg-grey-3 d-block w-50">Test</Badge>
    </>
  )
}

const MCJDetails = ({journey, labelLocale}) =>{
  let ds = journey.data_source || {};
  let data = journey.data || {};
  const addressInfo = (data.taluka || '') +' '+ (data.village || '') +' '+ (data.address || '') +' '+ (data.awc_name_number || '');
  const mobileNo = (data.cell_number_formatted || data.cell_number);

  const {routeJourney} = useJourneyHook();

  return(
    <>
     <div className="text-gray font-12 m-r-10 m-b-5"> Name </div>
      <div className="flex cgap-10 m-b-10 pointer" onClick={()=>routeJourney(journey)}>
        <span className="flex cgap-10 bold">
          {data.name}
        </span> 
        - 
        <span className="flex cgap-10 bold">
          {data.details ? <SpanRichTextView html={data.details}/> : <NameRequired/>}
        </span>
      </div>
      <div className="flex cgap-10 coldir-xs">
        <div className="flex aligncenter m-r-10">
          <PhoneIcon title={mobileNo || <MobileRequired/>}/>
        </div>
        <div className="m-r-10">
          <div className="flex aligncenter">
            <MapIcon title={addressInfo.length > 0 ? addressInfo : <AddressRequired/>}/>
          </div>
        </div>
      </div>
    </>
  )
}

const MCJDetails_2 = ({journey}) =>{
  return(
    <>
      <div className="text-gray font-12">User</div>
      <div className="dblock">{journey?.member_role?.role}</div>
      <UserName className="dblock" id={journey.last_update_by} role={journey.member_role}>
        {journey?.last_updated_user?.name}
      </UserName>
      <div className="dblock m-b-10">{Cs.formatUpdateDate(journey?.last_update_at)}</div>
    </>
  )
}

const AddressRequired = ({}) => <font className="c-bemedian">Address Not Provided</font>;
const MobileRequired = ({}) => <font className="c-bemedian">Mobile Not Provided</font>;
const NameRequired = ({}) => <font className="c-bemedian">Name Required</font>;

export {RecordId, MCJDetails, MCJDetails_2, AddressRequired};